'use strict';

export default Number.isInteger || function isInteger(value) {
  return (typeof value === 'number' && Number.isFinite(value) && Math.floor(value) === value);
};